"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = LifeInsurancePageTwo;
var _react = _interopRequireDefault(require("react"));
var _formik = require("formik");
var _LifeInsuranceFormControls = require("./LifeInsuranceFormControls");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function LifeInsurancePageTwo() {
  // Pulling formik context from higher up, which gives us access to formik state
  var {
    values: {
      beneficiary,
      annualPay,
      mortgageAmount,
      otherDebt,
      numOfKids
    },
    errors,
    touched,
    setFieldValue,
    values
  } = (0, _formik.useFormikContext)();
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, beneficiary == 'a dependent adult' && /*#__PURE__*/_react.default.createElement(_LifeInsuranceFormControls.DependentAge, {
    values: values,
    errors: errors,
    touched: touched
  }), beneficiary == 'my spouse/partner' && /*#__PURE__*/_react.default.createElement(_LifeInsuranceFormControls.PartnerAge, {
    values: values,
    errors: errors,
    touched: touched,
    includePeriod: true
  }), beneficiary == 'my spouse/partner & kids' && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_LifeInsuranceFormControls.PartnerAge, {
    values: values,
    errors: errors,
    touched: touched,
    includePeriod: false
  }), /*#__PURE__*/_react.default.createElement(_LifeInsuranceFormControls.NumberOfChildren, {
    values: values,
    errors: errors,
    touched: touched,
    numOfKids: numOfKids,
    setFieldValue: setFieldValue,
    comboScenarioInd: true
  }), /*#__PURE__*/_react.default.createElement(_LifeInsuranceFormControls.ChildrenAges, {
    values: values,
    errors: errors,
    touched: touched,
    setFieldValue: setFieldValue
  }), /*#__PURE__*/_react.default.createElement(_LifeInsuranceFormControls.CollegePlanInd, {
    values: values,
    setFieldValue: setFieldValue
  }), /*#__PURE__*/_react.default.createElement(_LifeInsuranceFormControls.CollegeTerm, {
    values: values,
    setFieldValue: setFieldValue
  })), beneficiary == 'my kids' && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_LifeInsuranceFormControls.NumberOfChildren, {
    values: values,
    errors: errors,
    touched: touched,
    numOfKids: numOfKids,
    setFieldValue: setFieldValue
  }), /*#__PURE__*/_react.default.createElement(_LifeInsuranceFormControls.ChildrenAges, {
    values: values,
    errors: errors,
    touched: touched,
    setFieldValue: setFieldValue
  }), /*#__PURE__*/_react.default.createElement(_LifeInsuranceFormControls.CollegePlanInd, {
    values: values,
    setFieldValue: setFieldValue
  }), /*#__PURE__*/_react.default.createElement(_LifeInsuranceFormControls.CollegeTerm, {
    values: values,
    setFieldValue: setFieldValue
  })), /*#__PURE__*/_react.default.createElement(_LifeInsuranceFormControls.AnnualPayAmount, {
    values: values,
    errors: errors,
    touched: touched,
    annualPay: annualPay,
    setFieldValue: setFieldValue
  }), /*#__PURE__*/_react.default.createElement(_LifeInsuranceFormControls.MortgageAmount, {
    values: values,
    errors: errors,
    touched: touched,
    mortgageAmount: mortgageAmount,
    setFieldValue: setFieldValue
  }), /*#__PURE__*/_react.default.createElement(_LifeInsuranceFormControls.OtherDebtAmount, {
    values: values,
    errors: errors,
    touched: touched,
    otherDebt: otherDebt,
    setFieldValue: setFieldValue
  }));
}